import { useEffect } from 'react';
import { useSocket } from 'sonata-platform-components';

type Options = {
  socketEventName: string;
  onEntityCreated: () => void;
};

export function useEntityCreatedSocket({ socketEventName, onEntityCreated }: Readonly<Options>) {
  const { offEvent, onEvent } = useSocket();

  const key = `entityCreatedSocket_${socketEventName}`;

  useEffect(() => {
    onEvent(key, socketEventName, () => {
      onEntityCreated();
    });

    return () => {
      offEvent(key);
    };
  }, [socketEventName]);
}
